import React, {useState, useEffect, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import SubMenuView from '../../views/subMenuView';
import {useMenu} from '../../../hooks/useMenu';
import ChannelConfig from './channel-config';
import FCFTN from './fcfTN';
import ConfigurationSummary from './config-summary';
import CommandsContext from '../../../context/commandsContext';

function SensorParameters() {
  const yesNoItem = [
    {id: 1, name: 'Yes', component: <FCFTN />},
    {id: 2, name: 'No', component: <ConfigurationSummary />},
  ];
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands}));
  }, []);

  // useEffect(() => {
  //   if (!leftPress || isKeypressDisabled) return;

  //   onComponent(<ChannelConfig />);
  // }, [leftPress]);

  return (
    <SubMenuView
      title="Sensor Parameters"
      menuItems={yesNoItem}
      content="Do you want to configure the sensor parameters?"
      isMenuDisabled
      onLeftCallback={() => onComponent(<ChannelConfig />)}
    />
  );
}
export default SensorParameters;
